import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Martina', 'Luca', 'Sofia', 'Marco', 'Giulia', 'Alessandro', 'Chiara', 'Francesco', 'Valentina', 'Matteo', 'Federica', 'Andrea', 'Elena', 'Lorenzo', 'Beatrice', 'Davide', 'Alice', 'Simone', 'Martina', 'Giorgia'];
const cities = ['Milano', 'Roma', 'Torino', 'Napoli', 'Bologna', 'Firenze', 'Genova', 'Palermo', 'Bari', 'Venezia', 'Verona', 'Padova', 'Catania', 'Cagliari', 'Perugia', 'Parma', 'Modena', 'Trieste', 'Brescia', 'Pisa'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function minutesAgo(): string {
  const n = Math.floor(Math.random() * 9) + 1;
  return `${n} ${n === 1 ? 'minuto' : 'minuti'} fa`;
}
export function PurchasePopup() {
  const [data, setData] = useState<{
    name: string;
    city: string;
    ago: string;
  } | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let timeoutId: number | undefined;
    let intervalId: number | undefined;
    const show = () => {
      setData({
        name: pick(names),
        city: pick(cities),
        ago: minutesAgo()
      });
      setVisible(true);
      timeoutId = window.setTimeout(() => setVisible(false), 6000);
    };
    const initial = window.setTimeout(show, 4000);
    intervalId = window.setInterval(show, 15000);
    return () => {
      window.clearTimeout(initial);
      if (timeoutId) window.clearTimeout(timeoutId);
      if (intervalId) window.clearInterval(intervalId);
    };
  }, []);
  if (!data) return null;
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs sm:max-w-sm transition-all duration-500 ${visible ? 'translate-y-0 opacity-100' : 'translate-y-[150%] opacity-0 pointer-events-none'}`} data-id="element-191">
      <div className="bg-white border border-green-200 rounded-2xl shadow-2xl p-3 sm:p-4 flex items-start gap-3 popup-anim" data-id="element-192">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-193">
          <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-194" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-195">
          <p className="text-sm font-bold text-slate-900 leading-tight" data-id="element-196">
            {data.name} da {data.city}
          </p>
          <p className="text-xs text-slate-600 leading-snug mt-0.5" data-id="element-197">
            ha appena acquistato{' '}
            <span className="font-semibold text-green-700" data-id="element-198">
              Carrera Veterinaria 360
            </span>
          </p>
          <p className="text-[10px] text-slate-400 mt-1" data-id="element-199">
            ✅ Acquisto verificato · {data.ago}
          </p>
        </div>
        <button onClick={() => setVisible(false)} aria-label="Chiudi" className="flex-shrink-0 text-slate-400 hover:text-slate-600" data-id="element-200">
          <XIcon className="w-4 h-4" data-id="element-201" />
        </button>
      </div>
    </div>;
}